module.exports = __webpack_public_path__ + "static/media/undraw_book.179b527e.svg";